import { LocalStorage } from "@/helpers/LocalStorage.ts"
import { Navigate } from "react-router"

export function AppRoot() {
  const token = LocalStorage.getSecret("token")
  if (token === null) {
    return <Navigate to="/login" />
  } else {
    return <Navigate to="/dashboard" />
  }
}
